import React, { lazy } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const GraphCatalogueHome = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-catalog-home" */ '../../pages/catalog/home'
		),
);
const GraphCatalogueNodes = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-catalog-nodes" */ '../../pages/catalog/nodes'
		),
);
const GraphCatalogueNode = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-catalog-node" */ '../../pages/catalog/node'
		),
);
const GraphCatalogueNodeRelationship = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-catalog-node-relationship" */ '../../pages/catalog/node-relationship'
		),
);

const CatalogAccessGate = ({ children }: { children: React.ReactNode }): React.JSX.Element => (
	<AppAccessGate appName="Catalog">{children}</AppAccessGate>
);

const GraphCatalogueHomeWithAccess = (): React.JSX.Element => (
	<CatalogAccessGate>
		<GraphCatalogueHome />
	</CatalogAccessGate>
);

const GraphCatalogueNodesWithAccess = (): React.JSX.Element => (
	<CatalogAccessGate>
		<GraphCatalogueNodes />
	</CatalogAccessGate>
);

const GraphCatalogueNodeWithAccess = (): React.JSX.Element => (
	<CatalogAccessGate>
		<GraphCatalogueNode />
	</CatalogAccessGate>
);

const GraphCatalogueNodeRelationshipWithAccess = (): React.JSX.Element => (
	<CatalogAccessGate>
		<GraphCatalogueNodeRelationship />
	</CatalogAccessGate>
);

const ROUTE_PREFIX = '/catalog' as const;

const graphCatalogueRoutesObject: Record<string, Route> = {
	home: {
		name: 'home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(GraphCatalogueHomeWithAccess),
	},
	nodes: {
		name: 'nodes',
		path: `${ROUTE_PREFIX}/nodes` as const,
		exact: true,
		component: componentWithSuspense(GraphCatalogueNodesWithAccess),
	},
	nodeRelationships: {
		name: 'node-relationships',
		path: `${ROUTE_PREFIX}/nodes/:nodeKey` as const,
		exact: true,
		component: componentWithSuspense(GraphCatalogueNodeWithAccess),
	},
	nodeRelationshipDetail: {
		name: 'node-relationships',
		path: `${ROUTE_PREFIX}/nodes/:nodeKey/:relationshipName` as const,
		exact: true,
		component: componentWithSuspense(GraphCatalogueNodeRelationshipWithAccess),
	},
} as const;

export const catalogRoutes: Routes = Object.values(graphCatalogueRoutesObject);
